import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import {
  SedsAlertBasicModule,
  SedsBasicButtonModule,
  SedsCheckboxModule,
  SedsFormFieldDropdownModule,
  SedsFormFieldTextModule,
  SedsLoadersSpinnerModule,
  SedsOutlinedButtonModule,
} from "experian-design-system";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { AlertModule } from "../../../shared/components/alert/alert.module";
import { FooterModule } from "../../../shared/components/footer/footer.module";
import { RecertificationConfirmationComponent } from "../../../shared/components/recertification-confirmation/recertification-confirmation.component";
import { MaterialModule } from "../../../shared/material.module";
import { SharedModule } from "../../../shared/shared.module";
import { DisplayErrorComponent } from "./components/display-error/display-error.component";
import { InfoCardComponent } from "./components/info-card/info-card.component";
import { StatusBarComponent } from "./components/status-bar/status-bar.component";
import { UserAddConfirmationComponent } from "./components/user-add-confirmation/user-add-confirmation.component";
import { UserAddComponent } from "./components/user-add/user-add.component";
import { UserDetailsComponent } from "./components/user-details/user-details.component";
import { UserEditConfirmationComponent } from "./components/user-edit-confirmation/user-edit-confirmation.component";
import { UserEditComponent } from "./components/user-edit/user-edit.component";
import { UserProfileChangeComponent } from "./components/user-profile-change/user-profile-change.component";
import { UserEffects } from "./state/effects/user.effects";
import { userReducer } from "./state/user.reducer";
import { UserProfileChangeConfirmationComponent } from "./components/user-profile-change/confirmation/user-profile-change-confirmation.component";
import { UserProfileChangeIncompleteComponent } from "./components/user-profile-change/user-incomplete/user-profile-change-incomplete.component";
import { MatFormFieldModule } from "@angular/material/form-field";
const routes: Routes = [
  {
    path: "",
    outlet: "sidenav",
    children: [
      {
        path: "add",
        component: UserAddComponent,
      },
      {
        path: "add-confirmation",
        component: UserAddConfirmationComponent,
      },
      {
        path: "details",
        component: UserDetailsComponent,
      },
      {
        path: "edit",
        component: UserEditComponent,
      },
      {
        path: "confirmation",
        component: UserEditConfirmationComponent,
      },      {
        path: "recertification",
        component: RecertificationConfirmationComponent,
      },      {
        path: "change-profile",
        component: UserProfileChangeComponent,
      },   
      {
        path: "profile-change-confirmation",
        component: UserProfileChangeConfirmationComponent
      },
         {
        path: "profile-change-incomplete",
        component: UserProfileChangeIncompleteComponent
      },
    ],
  },
];

@NgModule({  declarations: [
    UserAddComponent,
    UserAddConfirmationComponent,
    UserDetailsComponent,
    UserEditComponent,
    StatusBarComponent,
    InfoCardComponent,
    UserEditConfirmationComponent,
    DisplayErrorComponent,
    UserProfileChangeComponent,
  ],
  imports: [
    AlertModule,
    CommonModule,
    EffectsModule.forFeature([UserEffects]),
    FooterModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    StoreModule.forFeature("user", userReducer),
    SedsBasicButtonModule,
    SedsCheckboxModule,
    SedsFormFieldDropdownModule,
    SedsFormFieldTextModule,
    SedsOutlinedButtonModule,
    SedsLoadersSpinnerModule,
    SedsAlertBasicModule,
    SharedModule,
    NgxMaskDirective,
    MatFormFieldModule,
    NgxMaskPipe
  ],
  providers: [provideNgxMask({ validation: false })],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UsersModule {}
